import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, catchError, map, of, switchMap, take} from 'rxjs';

import * as CatalogActions from '@core/state/catalog/catalog.actions';
import * as fromCatalog from '@core/state/catalog/catalog.selectors';

import { SessionService } from '@core/services/session/session.service';
import { Client } from '@core/models/client';

@Injectable({
  providedIn: 'root'
})
export class GetProductVariantDesignResolver  {
  client: Client;
  constructor(
    private store: Store,
    private sessionService: SessionService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const { brand, style, color } = this.getRouteParams(route);
    this.client = this.sessionService.getActiveClient();

    this.dispatchActions(brand, style, color);

    return this.getProductVariantDesign();
  }

  private getRouteParams(route: ActivatedRouteSnapshot) {
    const brand = route.params.brand;
    const style = route.params.style;
    const color = route.queryParams.color;

    return { brand, style, color };
  }

  private dispatchActions(brand: string, style: string, color: string) {
    this.store.dispatch(CatalogActions.getProductVariant({ brand, style }));
    this.store.dispatch(CatalogActions.getProductVariantColor({ brand, style, color, clientId: this.client?.id, positions: [] }));
  }

  private getProductVariantDesign(): Observable<boolean> {
    const productVariant$ = this.store.pipe(select(fromCatalog.selectProductVariant), take(1));
    const productVariantColor$ = this.store.pipe(select(fromCatalog.selectProductVariantColor), take(1));

    return productVariant$.pipe(
      switchMap(productVariant => {
        if(productVariant) {
          return productVariantColor$.pipe(
            take(1),
            map(productVariantColor => productVariantColor != null),
            catchError(() => of(false)) // handle error
          )
        } else {
          return of(false);
        }
      }),
      catchError(() => of(false)) // handle error
    );
  }
}
